import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';

export const useAvailableQueues = (taskId: string, enabled?: boolean) => {
  const api = useGraphneAPI();

  return useQuery({
    queryKey: ['available-queues', taskId],
    queryFn: () => api.getGraphneTasksTaskidAvailableQueues({ taskId }),
    enabled,
  });
};
